import moment from 'moment';

export interface Quarter {
  id: number;
  label: string;
  displayLabel: string;
  months: string[];
}

const QUARTERLY_LANE_ORDER: Record<string, number> = {
  Events: 0,
  'Price Changes and Offers': 1,
  L1: 2,
  L2: 3,
  L3: 4,
  'All Other Releases': 5
};

/** Monthly view includes Key Dates as the first swimlane. */
export const MONTHLY_LANE_ORDER: Record<string, number> = {
  'Key Dates': 0,
  Events: 1,
  'Price Changes and Offers': 2,
  L1: 3,
  L2: 4,
  L3: 5,
  'All Other Releases': 6
};

const getLaneOrder = (type: string): number => {
  return QUARTERLY_LANE_ORDER[type] ?? 999;
};

export const getMonthlyLaneOrder = (type: string): number => {
  return MONTHLY_LANE_ORDER[type] ?? 999;
};

export const sortReleasesByOrder = (releases: any[]): any[] => {
  return [...releases].sort((a, b) => {
    const orderA = getLaneOrder(a.type);
    const orderB = getLaneOrder(b.type);
    return orderA - orderB;
  });
};

export function generateQuarters(
  startDate: string = moment().format('YYYY-MM-DD'),
  endDate: string = moment().add(6, 'months').format('YYYY-MM-DD')
): Quarter[] {
  const quarterMapping: Record<number, string[]> = {
    1: ['Dec', 'Jan', 'Feb'],
    2: ['Mar', 'Apr', 'May'],
    3: ['Jun', 'Jul', 'Aug'],
    4: ['Sep', 'Oct', 'Nov']
  };

  const getQuarterAndYear = (
    date: moment.Moment
  ): { quarter: number; year: number } => {
    const month = date.month();
    const year = date.year();
    if (month === 11) return { quarter: 1, year: year + 1 };
    if (month <= 1) return { quarter: 1, year };
    if (month <= 4) return { quarter: 2, year };
    if (month <= 7) return { quarter: 3, year };
    return { quarter: 4, year };
  };

  const start = moment(startDate);
  const end = moment(endDate);
  const { quarter: startQuarter, year: startYear } = getQuarterAndYear(start);
  const { quarter: endQuarter, year: endYear } = getQuarterAndYear(end);

  const quarters: Quarter[] = [];
  let currentQuarter = startQuarter;
  let currentYear = startYear;
  let quarterId = 1;

  while (
    currentYear < endYear ||
    (currentYear === endYear && currentQuarter <= endQuarter)
  ) {
    const label = `Q${currentQuarter} ${currentYear}`;
    const displayLabel = `Q${currentQuarter}'${currentYear
      .toString()
      .slice(-2)}`;
    const monthsForQuarter = quarterMapping[currentQuarter];

    quarters.push({
      id: quarterId,
      label,
      displayLabel,
      months: monthsForQuarter
    });

    quarterId += 1;
    currentQuarter += 1;
    if (currentQuarter > 4) {
      currentQuarter = 1;
      currentYear += 1;
    }
  }

  return quarters;
}
